// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"4a3267b5","496":"e23f0abc","513":"9e222bac"}[chunkId] + ".chunk.js";
};